"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createVariant = exports.convertTransition = exports.convertMotionConfigs = void 0;
var _tokens = require("@cbhq/cds-common/motion/tokens");
var _cdsUtils = require("@cbhq/cds-utils");
const _excluded = ["easing", "oneOffDuration", "duration", "delay"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convert CDS easing and duration tokens to framer transition values
 * @link https://www.framer.com/docs/animation/##transitions
 */
const convertTransition = transition => {
  const easing = transition.easing,
    oneOffDuration = transition.oneOffDuration,
    duration = transition.duration,
    delay = transition.delay,
    rest = _objectWithoutPropertiesLoose(transition, _excluded);
  let convertedDuration;
  if (duration) convertedDuration = duration && _tokens.durations[duration] / 1000;
  if (oneOffDuration) convertedDuration = oneOffDuration / 1000;
  const convertedEasing = easing ? _tokens.curves[easing] : undefined;
  const skipAnimation = (0, _cdsUtils.isStorybook)() || (0, _cdsUtils.isTest)();
  return Object.assign({}, rest, {
    ease: convertedEasing,
    duration: skipAnimation ? 0 : convertedDuration,
    delay: skipAnimation ? 0 : delay && delay / 1000
  });
};

/**
 * Convert CDS motion configs to framer transition styles
 * @param configs CDS Motion Configs
 * @returns framer transition styles
 */
exports.convertTransition = convertTransition;
const convertMotionConfigs = configs => configs.reduce((acc, {
  toValue,
  property,
  easing,
  duration,
  delay
}) => Object.assign({}, acc, {
  [property]: toValue,
  transition: Object.assign({}, acc.transition, {
    [property]: convertTransition({
      easing,
      duration,
      delay
    })
  })
}), {
  transition: {}
});

/**
 * Convert CDS motion configs to framer variant
 * @link https://www.framer.com/docs/component/###variants
 */
exports.convertMotionConfigs = convertMotionConfigs;
const createVariant = configs => {
  if (Array.isArray(configs)) {
    return convertMotionConfigs(configs);
  }
  if (typeof configs === 'object' && configs.tokens) {
    const tokens = configs.tokens,
      transitionEnd = configs.transitionEnd;
    return Object.assign({}, convertMotionConfigs(tokens), {
      transitionEnd
    });
  }
  return {};
};
exports.createVariant = createVariant;